<div class="container-fluid">
  <div class="report-header">
    <div>
      <h1 class="report-title">Tempo por Etapa</h1>
      <p class="report-subtitle">
        Descubra onde o tempo morre: duração real, variação e gargalos por etapa.
      </p>
    </div>
  </div>

  <div class="panel report-filters">
    <div class="report-filters__grid">
      <div class="filter-field">
        <label for="filterStart">Período (início)</label>
        <input
          id="filterStart"
          type="date"
          class="form-control"
          [(ngModel)]="filterStart"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterEnd">Período (fim)</label>
        <input
          id="filterEnd"
          type="date"
          class="form-control"
          [(ngModel)]="filterEnd"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterSeguradora">Seguradora</label>
        <select
          id="filterSeguradora"
          class="form-control"
          [(ngModel)]="filterSeguradora"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let seguradora of seguradoras" [value]="seguradora">
            {{ seguradora }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterResponsavel">Responsável</label>
        <select
          id="filterResponsavel"
          class="form-control"
          [(ngModel)]="filterResponsavel"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let responsavel of responsaveis" [value]="responsavel">
            {{ responsavel }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterEtapa">Etapa</label>
        <select
          id="filterEtapa"
          class="form-control"
          [(ngModel)]="filterEtapa"
          (change)="applyFilters()"
        >
          <option value="TODAS">Todas</option>
          <option *ngFor="let etapa of etapas" [value]="etapa.tipo">{{ etapa.nome }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterStatus">Status</label>
        <select
          id="filterStatus"
          class="form-control"
          [(ngModel)]="filterStatus"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option value="EM_ANDAMENTO">Em andamento</option>
          <option value="CONCLUIDO">Finalizado</option>
        </select>
      </div>
      <div class="filter-field filter-field--inline">
        <label>
          <input type="checkbox" [(ngModel)]="onlyConcluidas" (change)="applyFilters()" />
          Considerar apenas etapas concluídas
        </label>
      </div>
      <div class="filter-field">
        <label for="filterOutlier">Limite de outlier (dias)</label>
        <input
          id="filterOutlier"
          type="number"
          min="0"
          class="form-control"
          [(ngModel)]="outlierLimit"
          (change)="applyFilters()"
        />
      </div>
    </div>
  </div>

  <div class="report-kpis">
    <div class="kpi-card">
      <div class="kpi-label">Total de etapas analisadas</div>
      <div class="kpi-value">{{ totalEtapas }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Etapa mais lenta</div>
      <div class="kpi-value">{{ etapaMaisLenta?.etapaNome || '—' }}</div>
      <div class="kpi-meta">Média: {{ etapaMaisLenta?.media || 0 }} dias</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Etapa mais instável</div>
      <div class="kpi-value">{{ etapaMaisInstavel?.etapaNome || '—' }}</div>
      <div class="kpi-meta">
        variação: {{ etapaMaisInstavel ? etapaMaisInstavel.max - etapaMaisInstavel.min : 0 }} dias
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">% de etapas com atraso</div>
      <div class="kpi-value">{{ percentualAtraso | number: '1.0-1' }}%</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Tempo médio geral</div>
      <div class="kpi-value">{{ tempoMedioGeral }} dias</div>
    </div>
  </div>

  <div class="tabs-pill report-tabs" role="tablist">
    <button class="tab-btn" [class.active]="activeTab === 'resumo'" (click)="activeTab = 'resumo'">
      Resumo por etapa
    </button>
    <button
      class="tab-btn"
      [class.active]="activeTab === 'distribuicao'"
      (click)="activeTab = 'distribuicao'"
    >
      Distribuição (p95)
    </button>
    <button
      class="tab-btn"
      [class.active]="activeTab === 'criticos'"
      (click)="activeTab = 'criticos'"
    >
      Casos críticos
    </button>
  </div>

  <div *ngIf="activeTab === 'resumo'">
    <div class="stage-grid">
      <div class="stage-card" *ngFor="let item of resumoPorEtapa">
        <div class="stage-card__header">
          <div class="stage-title">{{ item.etapaNome }}</div>
          <span class="chip chip--warning" *ngIf="isGargalo(item)">Gargalo</span>
        </div>
        <div class="stage-metrics">
          <div class="metric">
            <span>Média</span>
            <strong>{{ item.media }} dias</strong>
          </div>
          <div class="metric">
            <span>P95</span>
            <strong>{{ item.p95 }} dias</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="panel report-table">
      <div class="wf-table-card">
        <table class="wf-table">
          <thead>
            <tr>
              <th>Etapa</th>
              <th class="col-count">Qtde</th>
              <th class="col-days">Média</th>
              <th class="col-days">Mediana</th>
              <th class="col-days">P95</th>
              <th class="col-days">Mínimo</th>
              <th class="col-days">Máximo</th>
              <th class="col-count">Em andamento</th>
              <th class="col-count">Atrasadas</th>
              <th class="col-count">SLA %</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of resumoPorEtapa">
              <td>{{ item.etapaNome }}</td>
              <td class="col-count">{{ item.amostras }}</td>
              <td class="col-days">{{ item.media }}</td>
              <td class="col-days">{{ item.mediana }}</td>
              <td class="col-days">{{ item.p95 }}</td>
              <td class="col-days">{{ item.min }}</td>
              <td class="col-days">{{ item.max }}</td>
              <td class="col-count">{{ item.emAndamento }}</td>
              <td class="col-count">{{ item.atrasadas }}</td>
              <td class="col-count">{{ item.sla !== null ? item.sla + '%' : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'distribuicao'">
    <div class="distribution-list">
      <div class="distribution-item" *ngFor="let item of resumoPorEtapa">
        <div class="distribution-title">{{ item.etapaNome }}</div>
        <div class="distribution-bars">
          <div class="bar-track">
            <div class="bar-mediana" [style.width]="getDistribuicaoWidth(item.mediana)"></div>
            <div class="bar-p95" [style.width]="getDistribuicaoWidth(item.p95)"></div>
          </div>
          <div class="distribution-values">
            <span>Mediana: {{ item.mediana }}d</span>
            <span>P95: {{ item.p95 }}d</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'criticos'">
    <div class="panel report-table">
      <div class="wf-table-card">
        <table class="wf-table">
          <thead>
            <tr>
              <th class="col-number">OS</th>
              <th>Placa / Veículo</th>
              <th class="col-stage">Etapa</th>
              <th class="col-user">Responsável</th>
              <th class="col-date">Início real</th>
              <th class="col-date">Fim real</th>
              <th class="col-days">Dias na etapa</th>
              <th class="col-days">Previsto</th>
              <th class="col-days">Estouro</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let record of criticalRecords">
              <td class="col-number">{{ formatOsNumero(record) }}</td>
              <td>{{ record.placa }} - {{ record.veiculo }}</td>
              <td class="col-stage">{{ record.etapaNome }}</td>
              <td class="col-user">{{ record.responsavel }}</td>
              <td class="col-date">{{ formatDate(record.realInicio) }}</td>
              <td class="col-date">{{ formatDate(record.realFim) }}</td>
              <td class="col-days">
                <span class="chip chip--danger" *ngIf="record.diasNaEtapa >= outlierLimit">
                  {{ record.diasNaEtapa }}d
                </span>
                <span *ngIf="record.diasNaEtapa < outlierLimit">{{ record.diasNaEtapa }}d</span>
              </td>
              <td class="col-days">
                {{ record.previstoDias !== null ? record.previstoDias : '—' }}
              </td>
              <td class="col-days">
                {{ record.previstoDias !== null ? record.diasNaEtapa - record.previstoDias : '—' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
